// CANONICAL COPY (GH #7115). src/constants/obligations/obl-privacy-by-design.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-privacy-by-design',
  title: 'Verify privacy by design and by default',
  description:
    "Confirm that the controller implements appropriate technical and organisational measures to give effect to data protection principles — such as data minimisation — both at the time of determination of the means of processing and at the time of processing itself, as required by GDPR Article 25. By default, only personal data necessary for each specific purpose shall be processed, and such data shall not be made accessible without the individual's intervention to an indefinite number of natural persons. Review the privacy-by-design procedure, SDLC / change-management gates and evidence of application to recent system changes.",
  category: 'compliance',
  scfIds: ['SCF-PRV-007'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Privacy by design procedure is published' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
